export type SATMonthsType =
  "Enero" |
  "Febrero" |
  "Marzo" |
  "Abril" |
  "Mayo" |
  "Junio" |
  "Julio" |
  "Agosto" |
  "Septiembre" |
  "Octubre" |
  "Noviembre" |
  "Diciembre" |
  "Enero_Febrero" |
  "Marzo_Abril" |
  "Mayo_Junio" |
  "Julio_Agosto" |
  "Septiembre_Octubre" |
  "Noviembre_Diciembre";

const SATMonthsEnum = {
  Enero: '01',
  Febrero: '02',
  Marzo: '03',
  Abril: '04',
  Mayo: '05',
  Junio: '06',
  Julio: '07',
  Agosto: '08',
  Septiembre: '09',
  Octubre: '10',
  Noviembre: '11',
  Diciembre: '12',
  Enero_Febrero: '13',
  Marzo_Abril: '14',
  Mayo_Junio: '15',
  Julio_Agosto: '16',
  Septiembre_Octubre: '17',
  Noviembre_Diciembre: '18',
};
Object.freeze(SATMonthsEnum);

export default SATMonthsEnum;
